import type { ReactNode } from 'react';

import { MediaFrame } from '@/shared/ui/media-frame';

import type { Media } from '../model/product';

export type ProductMediaProps = {
  media: Media | null;
  fallbackLabel: string;
  sizes: string;
  tint?: string | null;
  priority?: boolean;
  className?: string | undefined;
  placeholderStyle?: 'hatch' | 'plain';
  placeholderSub?: string;
  /** Photo crop ("center top" in cart and account rows); defaults to the media position. */
  position?: string | null;
  sketchSize?: string | null;
  children?: ReactNode;
};

/** Product photo, sketch or hatched placeholder with the product label. */
export function ProductMedia({
  media,
  fallbackLabel,
  sizes,
  tint = null,
  priority = false,
  className,
  children,
  placeholderStyle = 'hatch',
  placeholderSub,
  position,
  sketchSize = null,
}: ProductMediaProps) {
  const src = media && (media.kind === 'photo' || media.kind === 'sketch') ? media.src : null;
  return (
    <MediaFrame
      src={src}
      alt={media?.alt ?? fallbackLabel}
      kind={media?.kind === 'sketch' ? 'sketch' : 'photo'}
      position={position ?? media?.position ?? null}
      sketchSize={sketchSize}
      width={media?.width ?? null}
      height={media?.height ?? null}
      sizes={sizes}
      priority={priority}
      tint={tint}
      className={className}
      placeholder={{ label: media?.label ?? fallbackLabel, sub: placeholderSub ?? 'фото товара' }}
      placeholderStyle={placeholderStyle}
    >
      {children}
    </MediaFrame>
  );
}
